import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';

import { getStatementImage } from 'portal/src/api/StatementsService';

const useImgPreviewSrc = (
  imgPreviewId: string | null,
): {
  previewSrc: string | null;
  isFetchingImg: boolean;
  isError: boolean;
  isPdf: boolean;
} => {
  const {
    data: statementFile,
    isFetching: isFetchingImg,
    isError,
  } = useQuery({
    queryKey: ['statementImg', imgPreviewId],
    queryFn: async () => {
      return await getStatementImage(true)(imgPreviewId ?? '');
    },
    enabled: !!imgPreviewId,
  });

  const previewSrc = useMemo(
    () => (statementFile ? URL.createObjectURL(statementFile) : null),
    [statementFile],
  );

  useEffect(() => {
    return () => {
      if (previewSrc) {
        URL.revokeObjectURL(previewSrc);
      }
    };
  }, [previewSrc]);

  return {
    previewSrc,
    isFetchingImg,
    isError,
    isPdf: statementFile?.type && statementFile.type?.includes('application'),
  };
};

export default useImgPreviewSrc;
